
import "@/components/analytics/sentry.js";
import "ui/index.css";
import App from "./App.jsx";
import ContextProvider from "contexts/provider"; // Make sure the path is correct
import { Provider } from "react-redux";
import { QueryClientProvider } from "@tanstack/react-query";
import { createRoot } from "react-dom/client";
import { queryClient } from "utils/react-query.js";
import store from "store";

createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <ContextProvider>
        <App />
      </ContextProvider>
    </QueryClientProvider>
  </Provider>
);
